import { GA_EVENT_NAMES, SearchSuggestionType, GifGAEvent } from './types';

const sendGAEvent = (event: Record<string, string>) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(event);
};

/**
 * Tracks the user's country code.
 */
export const sendGeoEvent = (countryCode: string) => {
    sendGAEvent({
        event_name: GA_EVENT_NAMES.GEO,
        country_code: countryCode,
    });
};

/**
 * Tracks the selection of a search suggestion.
 * A suggestion can be selected by keyboard and by clicking.
 */
export const sendSearchSuggestionSelectEvent = (type: SearchSuggestionType, keyword: string) => {
    sendGAEvent({
        event: GA_EVENT_NAMES.GENERIC,
        event_name: GA_EVENT_NAMES.SEARCH_SUGGESTION_SELECTED,
        search_suggestion_type: type,
        search_suggestion_value: keyword,
    });
};

/**
 * Tracks when search is made without selecting a recommendation.
 */
export const sendGenericSearchEvent = (keyword: string) => {
    sendGAEvent({
        event: GA_EVENT_NAMES.GENERIC,
        event_name: GA_EVENT_NAMES.SEARCH,
        search_term: keyword,
    });
};

/**
 * Tracks when the layout change icon is clicked.
 */
export const sendLayoutChangeClickEvent = (fromTo: string) => {
    sendGAEvent({
        event: GA_EVENT_NAMES.GENERIC,
        event_name: GA_EVENT_NAMES.CLICK_LAYOUT_CHANGE_ICON,
        from_to: fromTo,
    });
};

/**
 * Tracks when a user has registered on the site.
 */
export const sendSignupEvent = (trId: string) => {
    sendGAEvent({
        event: GA_EVENT_NAMES.GENERIC,
        event_name: GA_EVENT_NAMES.SIGNUP,
        user_id: trId,
    });
};

/**
 * Tracks various GIF page events, such as button clicks.
 */
export const sendGifClickEvent = (eventName: GifGAEvent) => {
    sendGAEvent({
        event: GA_EVENT_NAMES.GENERIC,
        event_name: eventName,
    });
};
